import { useState } from 'react';

type Side = 'buy' | 'sell';

export function useOrderSelection() {
    const [selectedBuy, setSelectedBuy] = useState<Set<number>>(new Set());
    const [selectedSell, setSelectedSell] = useState<Set<number>>(new Set());

    const toggleAll = (side: Side, orders: { id: number }[]) => {
        const setter = side === 'buy' ? setSelectedBuy : setSelectedSell;
        setter(prev =>
            prev.size === orders.length
                ? new Set()
                : new Set(orders.map(o => o.id)),
        );
    };

    const toggle = (id: number, side: Side) => {
        const setter = side === 'buy' ? setSelectedBuy : setSelectedSell;
        setter(prev => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
    };

    const clearSide = (side: Side) => {
        (side === 'buy' ? setSelectedBuy : setSelectedSell)(new Set());
    };

    const selected = (side: Side) => (side === 'buy' ? selectedBuy : selectedSell);

    return { selectedBuy, selectedSell, selected, toggleAll, toggle, clearSide };
}